import * as yup from 'yup'
import useTrans from '../../../hooks/useTrans'

export default function getValidationSchema() {
  const t = useTrans()
  return yup.object().shape({
    azienda: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    partita_iva: yup
      .string()
      .required(t('Questo campo è obbligatorio'))
      .max(11, t('Massimo {0} caratteri', [11]))
      .nullable(),
    nome: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    email: yup
      .string()
      .email(t("L'email deve essere valida"))
      .required(t('Questo campo è obbligatorio'))
      .nullable(),
    telefono: yup
      .string()
      .required(t('Questo campo è obbligatorio'))
      .min(8, t('Minimo {0} caratteri', [8]))
      .nullable(),
    reparto: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    nazione: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    motivazione: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    messaggio: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
  })
}
